<h2 mat-dialog-title>Create Portfolio Document</h2>
<mat-dialog-content class="mat-typography">
    <app-portfolio-wizard></app-portfolio-wizard>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>